/**
 * 序列化URL的参数
 * **/
export function queryUrl(url) {
  let result = {},
    arr,
    str,
    key,
    key_arr,
    len;
  if (url.indexOf("?") !== -1) {
    arr = url.split("?");
    str = arr[1];
    arr = str.split("&");
    len = arr.length;
    if (len > 0) {
      for (let i = 0; i < len; i++) {
        key = arr[i];
        key_arr = key.split("=");
        result[key_arr[0]] = key_arr[1];
      }
    }
  }
  return result;
}

/**
 * 数字千分位 格式化
 * **/
export function formatNumber(num) {
  if (isNaN(num)) {
    throw new TypeError("num is not a number");
  }
  return ("" + num).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
}
// 防抖
export function debounce(fn, wait) {
  let timeout = null;
  return function () {
    timeout && clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(this, arguments);
    }, wait);
  };
}
// 限流
export function throttle(fn, interval) {
  let last = 0;
  return function () {
    const args = arguments;
    const now = Date.now();
    if (now - last >= interval) {
      last = now;
      fn.apply(this, args);
    }
  };
}
// 分钟
export function setCookie(cname, cvalue, exMins) {
  let d = new Date();
  d.setTime(d.getTime() + exMins * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function clearCookie(name) {
  setCookie(name, " ", -1);
}
let u = navigator.userAgent;
const platform = (typeof navigator !== "undefined" && navigator.platform) || "";
const maxTouchPoints =
  (typeof navigator !== "undefined" && navigator.maxTouchPoints) || 1;
export let isAndroid =
  u.indexOf("Android") > -1 ||
  u.indexOf("Adr") > -1 ||
  u.indexOf("XiaoMi") > -1; //android终端
export let isWeiXin = u.toLowerCase().indexOf("micromessenger") > -1; // 微信打开
export let isFaApp = u.indexOf("FlagshipFinancial") > -1; // 理财师App
export let isLenderApp =
  u.indexOf("FlagshipLender") > -1 || u.indexOf("toumi_zewu") > -1; // 客户端App
export let isToumiZewu =
  u.indexOf("FlagshipLender") > -1 || u.indexOf("toumi_zewu") > -1; // 客户端App
export let isFaH5 = (url, routerName) => {
  return (
    url.indexOf(
      `${location.origin}/flagship-planner-h5/index.html#/${routerName}`
    ) === 0 ||
    url.indexOf(`${location.origin}/flagship-planner-h5/#/${routerName}`) === 0
  );
};
export const isIOS =
  /\b(iPad|iPhone|iPod)(?=;)/.test(u) ||
  (platform === "MacIntel" && maxTouchPoints > 1);
// 延时
export function delay(time) {
  return new Promise((resolve) => {
    const timer = setTimeout(() => {
      resolve.apply(this, arguments);
      clearTimeout(timer);
    }, time);
  });
}
//删除url参数
export function delUrlParams(url, name) {
  let urlArr = url.split("?");
  if (urlArr.length > 1 && urlArr[1].indexOf(name) > -1) {
    let query = urlArr[1];
    let obj = {};
    let arr = query.split("&");
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[name];
    return (
      urlArr[0] +
      "?" +
      JSON.stringify(obj)
        .replace(/["{}]/g, "")
        .replace(/:/g, "=")
        .replace(/,/g, "&")
    );
  } else {
    return url;
  }
}
// 字符串截取函数
export function cutOut(val, num) {
  if (val.length > num) {
    return val.substr(0, num) + "...";
  } else {
    return val;
  }
}

/**
 * 获取url中单一属性
 * **/
export function getUrlSingleParam(key, url = location.search) {
  const reg = new RegExp("(\\?|&)" + key + "=([^&]*)(&|$)");
  const r = url.match(reg);
  if (r != null) {
    return unescape(r[2].split("#")[0]);
  }
  return null;
}
// 动态加载js
export function dynamicLoadScript(url) {
  return new Promise((resolve, reject) => {
    let script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (
          script.readyState === "loaded" ||
          script.readyState === "complete"
        ) {
          script.onreadystatechange = null;
          resolve("success");
        }
      };
    } else {
      //其他浏览器
      script.onload = function () {
        resolve("success");
      };
      script.onerror = function () {
        reject("fail");
      };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  });
}
// 如果接口返回null，则改为""
export function filterNull(object) {
  for (let i of Object.keys(object)) {
    object[i] = object[i] ? object[i] : "";
  }
  return object;
}
